/* Align text slots within each catalogue section. Supports AJAX and theme editor. */
(() => {
  let queued = false;
  const eligible = card => card.getClientRects().length &&
    !card.closest('.header, .header-drawer, .grid[data-view="list"]') &&
    !card.querySelector('.card--horizontal');
  function equalize(cards, selector) {
    const nodes = cards.flatMap(card => {
      const node = card.querySelector(selector);
      return node && node.getClientRects().length ? [node] : [];
    });
    if (nodes.length < 2) return;
    nodes.forEach(node => { node.style.minHeight = ''; });
    const height = Math.ceil(Math.max(...nodes.map(node => node.getBoundingClientRect().height)));
    nodes.forEach(node => {
      node.style.minHeight = `${height}px`;
      node.setAttribute('data-matt-equalized', '');
    });
  }
  function update() {
    queued = false;
    document.querySelectorAll('[data-matt-equalized]').forEach(node => {
      node.style.minHeight = '';
      node.removeAttribute('data-matt-equalized');
    });
    document.querySelectorAll('.shopify-section').forEach(section => {
      const collections = [...section.querySelectorAll('.collection-card:not(.collection-card--image-bg)')].filter(eligible);
      ['title', 'count', 'description'].forEach(slot => equalize(collections, `.matt-collection-${slot}`));
      const home = [...section.querySelectorAll('.matt-product')].filter(eligible);
      equalize(home, '.matt-product-body h3');
      equalize(home, '.matt-product-price');
      const products = [...section.querySelectorAll('.product-card-wrapper')].filter(eligible);
      equalize(products, '.card--block-title, .card__heading');
      equalize(products, '.card-information:has(.price)');
      equalize(products, '.card--block-button, .quick-add');
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', event => { if (event.target.tagName === 'IMG') schedule(); }, true);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  if (document.fonts) document.fonts.ready.then(schedule);
  schedule();
})();
